/**
 * Minh hoạ bước 2 trang "Bắt đầu": một khung chat thu nhỏ giống Hộp thư — khách nhắn qua Zalo, AI gợi ý câu
 * trả lời, nhân viên bấm Gửi. Chỉ để minh hoạ (không gọi API). Tin nhắn hiện lần lượt (CSS `.onb-chat-*` trong
 * index.css); bật "giảm chuyển động" thì hiện sẵn tất cả. Bước bị khoá → mờ đi.
 */
import { useTranslation } from 'react-i18next'
import { CheckCheck, Send, Sparkles } from 'lucide-react'
import type { StepState } from '@/lib/onboarding'
import { cn } from '@/lib/utils'

export function OnboardingChatIllustration({ state }: { state: StepState }) {
  const { t } = useTranslation('growth')
  return (
    <div
      aria-hidden
      className={cn(
        'mt-4 overflow-hidden rounded-xl border bg-card shadow-sm',
        state === 'locked' && 'opacity-60 grayscale',
      )}
    >
      {/* Đầu hội thoại */}
      <div className="flex items-center gap-2.5 border-b px-3 py-2.5">
        <span className="relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#fde3cf] text-xs font-semibold text-[#c2410c]">
          LH
          <img
            src="/brand-logos/zalo.svg"
            alt=""
            className="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full bg-white ring-2 ring-card"
          />
        </span>
        <div className="min-w-0 flex-1 leading-tight">
          <p className="truncate text-sm font-medium">{t('onboardingChat.customerName')}</p>
          <p className="text-[11px] text-muted-foreground">{t('onboardingChat.justMessaged')}</p>
        </div>
        <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-medium text-primary">{t('onboardingChat.newBadge')}</span>
      </div>

      {/* Nội dung */}
      <div className="space-y-2.5 bg-muted/30 px-3 py-3 text-[13px]">
        <div className="onb-chat-in flex max-w-[80%] flex-col items-start" style={{ animationDelay: '0.2s' }}>
          <p className="rounded-2xl rounded-bl-md bg-card px-3 py-2 shadow-sm">
            {t('onboardingChat.customerQuestion')}
          </p>
          <span className="mt-0.5 pl-1 text-[10px] text-muted-foreground">09:41</span>
        </div>

        {/* Gợi ý của AI */}
        <div
          className="onb-chat-in ml-auto max-w-[85%] rounded-xl border border-dashed border-primary/40 bg-primary/[0.06] px-3 py-2"
          style={{ animationDelay: '1.1s' }}
        >
          <p className="mb-1 flex items-center gap-1 text-[11px] font-medium text-primary">
            <Sparkles className="h-3 w-3" /> {t('onboardingChat.aiSuggests')}
          </p>
          <p className="text-muted-foreground">
            {t('onboardingChat.aiAnswer')}
          </p>
        </div>

        <div className="onb-chat-in ml-auto flex max-w-[80%] flex-col items-end" style={{ animationDelay: '2s' }}>
          <p className="rounded-2xl rounded-br-md bg-primary px-3 py-2 text-primary-foreground shadow-sm">
            {t('onboardingChat.aiAnswer')}
          </p>
          <span className="mt-0.5 flex items-center gap-1 pr-1 text-[10px] text-muted-foreground">
            09:42 <CheckCheck className="h-3 w-3 text-primary" /> {t('onboardingChat.sent')}
          </span>
        </div>
      </div>

      {/* Ô soạn tin */}
      <div className="flex items-center gap-2 border-t px-3 py-2">
        <span className="min-w-0 flex-1 truncate rounded-lg bg-muted/60 px-3 py-1.5 text-[13px] text-muted-foreground">
          {t('onboardingChat.composePlaceholder')}
        </span>
        <span className="onb-chat-send flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground">
          <Send className="h-4 w-4" />
        </span>
      </div>
    </div>
  )
}
